import type { TExpenseFieldArrayName } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/expenses/types.ts';
import { FinancialStatementForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';

export const EXPENSE_TABLE_HEADERS = [
  'Рядок фінансової звітності',
  'Складова витрат',
  'Сума, тис. од.',
  'Питома вага, %',
] as const;

export const EXPENSE_TABLE_COLUMN_WIDTHS = ['22%', '42%', '20%', '16%'] as const;

export const EXPENSE_TABLE_MIN_WIDTH = 820;

const EXPENSE_GROUPS_BY_FINANCIAL_STATEMENT_FORM: Record<
  FinancialStatementForm,
  Array<{ name: TExpenseFieldArrayName; title: string }>
> = {
  [FinancialStatementForm.Large]: [
    {
      name: 'expensesAnnual',
      title: '11.1. Розшифровка витрат рядків Форми №2 за річною звітністю',
    },
    {
      name: 'expensesQuarterly',
      title: '11.2. Розшифровка витрат рядків Форми №2 за квартальною звітністю',
    },
  ],
  [FinancialStatementForm.SmallOrSimplified]: [
    {
      name: 'expensesAnnual',
      title:
        '11.1. Розшифровка витрат рядків Форми №2-м / Форми №2-мс за річною звітністю',
    },
    {
      name: 'expensesQuarterlySmall',
      title:
        '11.3. Розшифровка фінансових витрат та амортизації Форми №2-м / Форми №2-мс за квартальною звітністю',
    },
  ],
};

export const getExpenseGroups = (financialStatementForm: FinancialStatementForm) =>
  EXPENSE_GROUPS_BY_FINANCIAL_STATEMENT_FORM[financialStatementForm];
